import axios from 'axios';
import { Employee, Site, TreatmentCategory } from './models';

const service = axios.create({
		baseURL: '/api/ajax/DepartmentApi/'
	}),
	employeeService = axios.create({
		baseURL: '/api/ajax/EmployeeApi/'
	}),
	treatmentService = axios.create({
		baseURL: '/api/ajax/TreatmentApi/'
	});

export default {
	/**
	 * Get all departments within provided `chainId`
	 * @param {Number} chainId - The chain to get all departments from.
	 * @returns {Promise<Site[]|Boolean>} Array of departments, or `false` if request failed.
	 */
	async GetDepartments(chainId = 0) {
		const result = await axios.post('/api/ajax/DepartmentApi/GetDepartments', { chainId });
		switch (Object(result.data).ResponseCode) {
			case 200:
				return result.data.SalonList.map(salon => new Site(salon));

			case 204:
				return [];

			default:
				return false;
		}
	},

	/**
	 * Get all employees by `siteId`
	 * @param {Number} siteId - The siteId to get employees from.
	 * @returns {Promise<Employee[]|Boolean>} Array of employees, or `false` if request failed.
	 */
	async GetEmployees(siteId = 0) {
		const result = await axios.get(`/api/ajax/EmployeeApi/GetEmployees?SiteId=${siteId}&istpn=false`);
		switch (Object(result.data).ResponseCode) {
			case 200:
			case 204:
				return result.data.EmployeeList.map(employee => new Employee(employee));

			default:
				return false;
		}
	},

	/**
	 * Get all treatments with categories by `siteId` and `customerId`.
	 * @param {Object} params
	 * @param {String} params.customerId
	 * @param {Number} params.siteId
	 */
	async GetTreatments({ customerId = '', siteId = 0 }) {
		const result = await axios.get(`${location.origin}/api/ajax/TreatmentApi/GetTreatmentCategories?siteId=${siteId}&customerId=${customerId}&istpn=false`);
		switch (Object(result.data).ResponseCode) {
			case 200:
			case 204:
				return result.data.TreatmentCategoryList.map(category => new TreatmentCategory(category));

			default:
				return false;
		}
	},
	/**
	 * Get all siteIds within provided `chainId`
	 * @param {Number} chainId - The chain to get all departments from.
	 * @returns {Promise<int[]|Boolean>} Array of siteIds, or `false` if request failed.
	 */
	async GetSiteIdsByChainId(chainId = 0) {
		const result = await axios.post('/api/ajax/DepartmentApi/GetSiteIdsByChainId', { chainId });
		switch (Object(result.data).ResponseCode) {
			case 200:
				return result.data.SiteIds;

			case 204:
				return [];

			default:
				return false;
		}
	},
};
